var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tarifas" },
    [
      _c(
        "v-dialog",
        {
          attrs: { width: "500" },
          model: {
            value: _vm.showInfoDialog,
            callback: function($$v) {
              _vm.showInfoDialog = $$v
            },
            expression: "showInfoDialog"
          }
        },
        [
          _c(
            "v-toolbar",
            { attrs: { dark: "", color: "primary" } },
            [
              _c(
                "v-toolbar-title",
                {
                  staticStyle: {
                    "font-size": "17px",
                    "margin-left": "10px !important"
                  }
                },
                [_vm._v("Editar Grupo " + _vm._s(_vm.patente))]
              )
            ],
            1
          ),
          _c("v-card", { attrs: { "max-height": "300" } }, [
            _c(
              "div",
              { staticStyle: { "margin-left": "20px", width: "80%" } },
              [
                _c("v-text-field", {
                  attrs: { label: "Grupo..." },
                  model: {
                    value: _vm.grupo,
                    callback: function($$v) {
                      _vm.grupo = $$v
                    },
                    expression: "grupo"
                  }
                }),
                _c(
                  "v-btn",
                  {
                    attrs: { color: "#FFE700" },
                    on: {
                      click: function($event) {
                        return _vm.guardar()
                      }
                    }
                  },
                  [_vm._v("Guardar grupo ")]
                )
              ],
              1
            )
          ])
        ],
        1
      ),
      _c(
        "v-flex",
        { staticStyle: { width: "30%" }, attrs: { sm12: "", md12: "" } },
        [
          _c("v-text-field", {
            attrs: { label: "Buscar..." },
            on: { input: _vm.onFilterPeajes, keydown: _vm.preventEnter },
            model: {
              value: _vm.buscarVehiculo,
              callback: function($$v) {
                _vm.buscarVehiculo = $$v
              },
              expression: "buscarVehiculo"
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "gridcard rounded-card" },
        [
          _c("MantenedorGridSinCodigo", {
            attrs: {
              "grid-options": _vm.gridOptions,
              "funcionalidad-id": _vm.funcionalidad
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }